import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';

const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));

function Dot({ state }) {
  const c = state === 'ok' ? 'var(--ok)' : state === 'warn' ? 'var(--warn)' : state === 'off' ? 'var(--muted)' : 'var(--alert)';
  return <span className="s-dot" style={{ background: c, boxShadow: `0 0 0 3px color-mix(in srgb, ${c} 22%, transparent)` }} />;
}

function rilevaProblemi(s, a456, acop, assm, agea, aind) {
  const P = [];
  if (!s.mongo_ok) P.push({ lvl: 'critico', msg: 'MongoDB non raggiungibile' });
  const dRec = s.disco?.recordings;
  if (dRec?.used_pct >= 95) P.push({ lvl: 'critico', msg: `Disco quasi pieno (${dRec.used_pct}%)` });
  else if (dRec?.used_pct >= 90) P.push({ lvl: 'warn', msg: `Disco in esaurimento (${dRec.used_pct}%)` });
  if (!s.licenza?.file_presente && s.licenza?.enforce) P.push({ lvl: 'critico', msg: 'Licenza assente (enforce attivo)' });
  if (a456?.job?.status === 'standby') P.push({ lvl: 'warn', msg: 'AI 456 in standby (disservizio)' });
  if (acop?.job?.status === 'standby') P.push({ lvl: 'warn', msg: 'AI copertura in standby' });
  if (agea?.job && agea.job.total && agea.job.disservizi >= agea.job.total) P.push({ lvl: 'warn', msg: 'Portale Vodafone in disservizio' });
  if (assm?.agente_attivo && !assm?.job && (assm?.esauriti?.length > 0)) P.push({ lvl: 'warn', msg: 'AI SSMATE in attesa crediti' });
  if (aind?.job?.standby) P.push({ lvl: 'warn', msg: 'AI Indaga in standby (possibile blocco Google)' });
  const nu = s.numeri || {};
  if (nu.errore != null) {
    const validi = (nu.tim || 0) + (nu.non_tim || 0) + nu.errore;
    const rate = validi ? nu.errore / validi : 0;
    if (nu.errore >= 20 && rate >= 0.05) P.push({ lvl: 'warn', msg: `Tasso errori 456 alto (${Math.round(rate * 100)}%)` });
  }
  return P;
}
function Row({ label, children }) {
  return <div className="s-row"><span className="s-l">{label}</span><span className="s-v">{children}</span></div>;
}
function Card({ title, children }) {
  return <div className="s-card"><div className="s-title">{title}</div>{children}</div>;
}

export default function SalutePage() {
  const [s, setS] = useState(null);
  const [a456, setA456] = useState(null);
  const [acop, setAcop] = useState(null);
  const [assm, setAssm] = useState(null);
  const [agea, setAgea] = useState(null);
  const [aind, setAind] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/salute`).then((r) => setS(r.data)).catch(() => {});
  }, []);
  const loadAg = useCallback(() => {
    axios.get(`${API}/agent/status`).then((r) => setA456(r.data)).catch(() => {});
    axios.get(`${API}/copertura/stato`).then((r) => setAcop(r.data)).catch(() => {});
    axios.get(`${API}/ssmate/bulk/preview`).then((r) => setAssm(r.data)).catch(() => {});
    axios.get(`${API}/gea/stato`).then((r) => setAgea(r.data)).catch(() => {});
    axios.get(`${API}/indaga/stato`).then((r) => setAind(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load(); loadAg();
    const t1 = setInterval(load, 10000);
    const t2 = setInterval(loadAg, 5000);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, [load, loadAg]);

  if (!s) return <div className="m-empty">Caricamento…</div>;

  const dRec = s.disco?.recordings;
  const diskWarn = dRec && dRec.used_pct != null && dRec.used_pct >= 90;
  const running456 = !!a456?.running && !a456?.in_attesa;
  const acceso456 = !!a456?.attivo;
  const jobCop = acop?.job;
  const accesoCop = !!acop?.agente_attivo;

  const problemi = rilevaProblemi(s, a456, acop, assm, agea, aind);
  const critico = problemi.some((p) => p.lvl === 'critico');

  return (
    <>
      <div className={`s-banner ${problemi.length === 0 ? 'ok' : critico ? 'bad' : 'warn'}`}>
        {problemi.length === 0 ? (
          <b>✅ Tutto regolare</b>
        ) : (
          <>
            <b>⚠️ {problemi.length} {problemi.length === 1 ? 'problema' : 'problemi'}</b>
            <ul>{problemi.map((p, i) => <li key={i} className={p.lvl}>{p.msg}</li>)}</ul>
          </>
        )}
      </div>

      <Card title="Stato sistema">
        <Row label="MongoDB"><Dot state={s.mongo_ok ? 'ok' : 'bad'} />{s.mongo_ok ? `connesso (${s.db})` : 'non raggiungibile'}</Row>
        <Row label="AI 456"><Dot state={running456 ? 'ok' : acceso456 ? 'warn' : 'off'} />{running456 ? 'in esecuzione' : acceso456 ? 'in attesa' : 'spento'}</Row>
        <Row label="AI copertura"><Dot state={jobCop ? 'ok' : accesoCop ? 'warn' : 'off'} />{jobCop ? 'in esecuzione' : accesoCop ? 'in attesa' : 'spento'}</Row>
        <Row label="AI SSMATE"><Dot state={assm?.job ? 'ok' : assm?.agente_attivo ? 'warn' : 'off'} />{assm?.job ? 'in esecuzione' : assm?.agente_attivo ? (assm?.esauriti?.length ? 'in attesa crediti' : 'in attesa') : 'spento'}</Row>
        <Row label="AI VF"><Dot state={agea?.job ? 'ok' : agea?.agente_attivo ? 'warn' : 'off'} />{agea?.job ? 'in esecuzione' : agea?.agente_attivo ? 'in attesa' : (agea?.abilitata === false ? 'disabilitato' : 'spento')}</Row>
        <Row label="AI Indaga"><Dot state={aind?.job && !aind?.in_attesa ? 'ok' : aind?.agente_attivo ? 'warn' : 'off'} />{aind?.job ? 'in esecuzione' : aind?.agente_attivo ? (aind?.in_attesa ? (aind?.motivo_attesa || 'in attesa') : 'in attesa') : (aind?.abilitata === false ? 'disabilitato' : 'spento')}</Row>
        <Row label="Licenza"><Dot state={s.licenza?.file_presente ? 'ok' : 'warn'} />{s.licenza?.file_presente ? 'attiva' : 'assente'}{s.licenza?.enforce ? ' · enforce ON' : ' · enforce OFF'}</Row>
      </Card>

      <Card title="Numeri">
        <div className="m-chips" style={{ margin: '2px 0 0' }}>
          <div className="m-chip"><div className="cn">{nf(s.numeri.total)}</div><div className="cl">Totale</div></div>
          <div className="m-chip"><div className="cn">{nf(s.numeri.pending)}</div><div className="cl">In attesa</div></div>
          <div className="m-chip"><div className="cn">{nf(s.numeri.scaduti)}</div><div className="cl">Scaduti</div></div>
          <div className="m-chip"><div className="cn">{nf(s.numeri.esportabili)}</div><div className="cl">Esportabili</div></div>
          <div className="m-chip"><div className="cn">{nf(s.numeri.blacklist)}</div><div className="cl">Blacklist</div></div>
        </div>
      </Card>

      <Card title="SIP / Trascrizione">
        <Row label="Modalità SIP">{s.sip.use_builtin ? 'Integrato (PJSUA2)' : 'MicroSIP'}</Row>
        <Row label="Linee configurate"><b>{nf(s.sip.linee)}</b></Row>
        <Row label="Whisper">{s.whisper.model || '—'} · {s.whisper.device || '—'}</Row>
      </Card>

      <Card title="Disco">
        <Row label="Registrazioni"><Dot state={diskWarn ? 'warn' : 'ok'} />{dRec ? `${nf(dRec.free_gb)} / ${nf(dRec.total_gb)} GB · ${dRec.used_pct}%` : '—'}</Row>
        <Row label="File registrazioni">{nf(s.disco?.recordings_files)}</Row>
      </Card>

      <Card title="Servizi">
        <Row label="Copertura TIM"><Dot state={s.copertura_abilitata ? 'ok' : 'warn'} />{s.copertura_abilitata ? 'abilitata' : 'disabilitata'}</Row>
        <Row label="Notifiche email"><Dot state={s.notifiche ? 'ok' : 'warn'} />{s.notifiche ? 'attive' : 'spente'}</Row>
        <Row label="Report automatico"><Dot state={s.report ? 'ok' : 'warn'} />{s.report ? 'attivo' : 'spento'}</Row>
      </Card>

      <Card title="Agente Indaga (completa indirizzi)">
        <Row label="Stato"><Dot state={aind?.job && !aind?.in_attesa ? 'ok' : aind?.agente_attivo ? 'warn' : 'off'} />{aind?.job ? 'in esecuzione' : aind?.agente_attivo ? (aind?.in_attesa ? (aind?.motivo_attesa || 'in attesa') : 'in attesa') : (aind?.abilitata === false ? 'disabilitato' : 'spento')}</Row>
        <Row label="Completabili ora"><b>{nf(aind?.eligibili)}</b></Row>
        <Row label="Tetto giornaliero">{nf(aind?.tetto)}</Row>
        {aind?.job && <Row label="Avanzamento (oggi)">{nf(aind.job.completed)}/{nf(aind.job.total)}</Row>}
        {aind?.job && <Row label="Completati / non conf.">{nf(aind.job.completati)} / {nf(aind.job.non_confermati)}</Row>}
        {aind?.job && <Row label="Non trovati / errori">{nf(aind.job.non_trovati)} / {nf(aind.job.errori)}</Row>}
      </Card>

      <div className="m-sub" style={{ textAlign: 'center', margin: '4px 0 2px' }}>
        Aggiornato {new Date(s.ora).toLocaleTimeString('it-IT')}
      </div>
    </>
  );
}
